import { Image, Text } from '@user-portal/wikr-components';
import styled from 'styled-components';

import { color } from 'theme/selectors';

export const Card = styled.div`
    width: 300px;
    height: 380px;
    position: relative;
    border-radius: 20px;
    box-shadow: 0 14px 14px 0 rgba(0, 0, 0, 0.09), 0 4px 8px 0 rgba(0, 0, 0, 0.1);
`;

export const Img = styled(Image)`
    border-radius: 20px;
`;

export const CurrentPlan = styled(Text)`
    position: absolute;
    left: 20px;
    top: 20px;
    padding: 4px 12px;
    border-radius: 14px;
    background: ${color('text-main')};
`;

export const Info = styled.div`
    border-radius: inherit;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    padding: 24px 16px;
`;
